import angular from 'angular';
export class StripeFactory {
    constructor(stripePublishable) {
        this.stripePublishable = stripePublishable;
        this.instances = {};
    }
    async getDoxyStripeInstance() {
        return this.getInstance(this.stripePublishable);
    }
    async getCustomStripeInstance(customStripePublishable) {
        return this.getInstance(customStripePublishable);
    }
    async getInstance(stripePublishable) {
        if (typeof window !== 'undefined' && window.Stripe == null) {
            await window.loadScript('https://js.stripe.com/v3/');
        }
        const cached = this.instances[stripePublishable];
        if (cached) {
            return cached;
        }
        const instance = window.Stripe(stripePublishable);
        this.instances[stripePublishable] = instance;
        return instance;
    }
}
export default angular
    .module('doxy.common.services.stripe', [])
    .service('stripe', StripeFactory).name;
